import {useEffect, useRef, useState} from 'react'
import {CrudProvider} from '../../../../../services/loggedin/CrudContext'
import {FormComponent} from '../../../../parts/crud/Form'

import {useIntl} from 'react-intl'
import clsx from 'clsx'
import Map from 'ol/Map'
import Feature from 'ol/Feature'
import {Point} from 'ol/geom'
import TileLayer from 'ol/layer/Tile'
import VectorLayer from 'ol/layer/Vector'
import {fromLonLat} from 'ol/proj'
import {OSM} from 'ol/source'
import VectorSource from 'ol/source/Vector'
import View from 'ol/View'
import Swal from 'sweetalert2'
import {processGet} from '../../../../../services/api'
import Style from 'ol/style/Style'
import Icon from 'ol/style/Icon'

import withReactContent from 'sweetalert2-react-content'
import {useParams} from 'react-router-dom'
import {Loader} from '@googlemaps/js-api-loader'
import {CloseButton} from 'react-bootstrap'
const MySwal = withReactContent(Swal)

export const ServerForm = () => {
  const intl = useIntl()
  const featureStyle = function (feature, resolution) {
    var image: null | string = null
    if (feature.get('serverStatus') === 2) {
      image = '/media/server-online.png'
    } else {
      image = '/media/server-offline.png'
    }
    var style = new Style({
      image: new Icon({
        anchor: [0.5, 46],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        src: image,
      }),
    })
    return [style]
  }
  const [serverCoordinates, setServerCoordinates] = useState([])
  const mapElement = useRef<any>()
  const [map, setMap] = useState<Map>()
  const [featuresLayer, setFeaturesLayer] = useState<any>()
  const params = useParams()

  useEffect(() => {
    const fetchCoordinates = async (loader) => {
      const {Map} = await loader.importLibrary('maps')
      const {Marker} = await loader.importLibrary('marker')
      const {LatLngBounds, Size, Point, ControlPosition} = await loader.importLibrary('core')
      const response: any = await processGet('system-settings/servers/coordinates', {
        serverId: params.id,
      })

      const map = new Map(mapElement.current, {
        center: {lat: 0, lng: 0},
        zoom: 13,
        zoomControl: true,
        zoomControlOptions: {
          position: ControlPosition.TOP_RIGHT,
        },
      })
      const bounds = new LatLngBounds()

      response.data.forEach((server: any) => {
        if (server.lat == null || server.lng == null) return

        var image: null | string = null
        if (server.serverStatus === 2) {
          image = '/media/server-online.png'
        } else {
          image = '/media/server-offline.png'
        }
        const marker = new Marker({
          position: {lat: parseFloat(server.lat), lng: parseFloat(server.lng)},
          map: map,
          title: server.serverDescription,
          icon: {
            url: image,
            scaledSize: new Size(40, 40), // Ora funziona
            origin: new Point(0, 0), // Ora funziona
            anchor: new Point(20, 40), // Ora funziona
          },
        })

        marker.addListener('click', () => {
          handleMarkerClick(server)
        })
        bounds.extend(marker.getPosition())
      })

      map.fitBounds(bounds)
    }

    const initMap = async () => {
      const loader = new Loader({
        apiKey: window['config'].gmaps_api_key,
        version: 'weekly',
        libraries: [], // opzionale, se serve Places API
      })

      fetchCoordinates(loader)
    }

    initMap()
  }, [])

  function handleMarkerClick(data: any) {
    var content = `<h3>Server ${data.serverDescription}</h3>
                    <strong>${intl.formatMessage({
                      id: 'SYSTEM_SETTINGS.SERVERS.SERVER_STATUS',
                    })}: </strong> ${data.serverStatus === 2 ? 'online' : 'offline'}
                    <strong>${intl.formatMessage({
                      id: 'SYSTEM_SETTINGS.SERVERS.USERNAME',
                    })}: </strong> ${data.serverUsername}
                    <strong>${intl.formatMessage({
                      id: 'SYSTEM_SETTINGS.SERVERS.LAST_ONLINE',
                    })}: </strong> ${intl.formatDate(data.lastOnlineStatus)} ${intl.formatTime(
      data.lastOnlineStatus
    )}
                    <strong>${intl.formatMessage({
                      id: 'SYSTEM_SETTINGS.SERVERS.LAST_OFFLINE',
                    })}: </strong> ${intl.formatDate(data.lastOfflineStatus)} ${intl.formatTime(
      data.lastOfflineStatus
    )}`
    let position: any = [920, 283]
    MySwal.fire({
      toast: true,
      position: position,
      confirmButtonText: intl.formatMessage({id: 'GENERIC.EDIT'}),
      cancelButtonText: intl.formatMessage({id: 'GENERIC.OK'}),
      showCancelButton: true,
      showConfirmButton: false,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer
        toast.onmouseleave = Swal.resumeTimer
      },

      title: content,
    })
  }
  /*  useEffect(() => {
   
    const fetchCoordinates = async () => {
      const response: any = await processGet('system-settings/servers/coordinates', {
        serverId: params.id,
      })
      setServerCoordinates(response.data)
      var iconFeatures: Array<Feature> = []
      for (var i = 0; i < response.data.length; i++) {
        if (response.data[i].lat == null || response.data[i].lng == null) continue
        const feature = new Feature(
          Object.assign(
            {
              geometry: new Point(fromLonLat([response.data[i].lng, response.data[i].lat])),
              name: response.data[i].serverDescription,
              serverid: response.data[i].id,
            },
            response.data[i]
          )
        )
        iconFeatures.push(feature)
      }

      if (iconFeatures.length === 0) {
        return
      }

      const featuresLayer = new VectorLayer({
        source: new VectorSource({
          features: iconFeatures,
        }),
        style: featureStyle,
      })

      const map = new Map({
        target: mapElement.current,
        layers: [
          // USGS Topo
          new TileLayer({
            source: new OSM(),
          }),

          featuresLayer,
        ],
        view: new View({
          projection: 'EPSG:3857',
          center: [0, 0],
          zoom: 2,
        }),
        controls: [],
      })
      let extent: any =
        featuresLayer?.getSource()?.getExtent() != undefined
          ? featuresLayer?.getSource()?.getExtent()
          : null

      map.getView().fit(extent, {
        padding: [60, 60, 60, 60],
      })
      if (parseInt(map.getView().getZoom() + '') > 12) {
        map.getView().setZoom(12)
      }

      map.render()

      map.on('click', function (evt: any) {
        console.log(evt)
        var feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
          return feature
        })

        if (feature) {
          var content = `<h3>Server ${feature.get('name')}</h3>
                <strong>${intl.formatMessage({
                  id: 'SYSTEM_SETTINGS.SERVERS.SERVER_STATUS',
                })}: </strong> ${feature.get('serverStatus') === 2 ? 'online' : 'offline'}
                <strong>${intl.formatMessage({
                  id: 'SYSTEM_SETTINGS.SERVERS.USERNAME',
                })}: </strong> ${feature.get('serverUsername')}
                <strong>${intl.formatMessage({
                  id: 'SYSTEM_SETTINGS.SERVERS.LAST_ONLINE',
                })}: </strong> ${intl.formatDate(
            feature.get('lastOnlineStatus')
          )} ${intl.formatTime(feature.get('lastOnlineStatus'))}
                <strong>${intl.formatMessage({
                  id: 'SYSTEM_SETTINGS.SERVERS.LAST_OFFLINE',
                })}: </strong> ${intl.formatDate(
            feature.get('lastOfflineStatus')
          )} ${intl.formatTime(feature.get('lastOfflineStatus'))}`
          let position: any = [920, 283]
          MySwal.fire({
            toast: true,
            position: position,
            confirmButtonText: intl.formatMessage({id: 'GENERIC.EDIT'}),
            cancelButtonText: intl.formatMessage({id: 'GENERIC.OK'}),
            showCancelButton: true,
            showConfirmButton: false,
            timerProgressBar: false,
            didOpen: (toast) => {
              toast.onmouseenter = Swal.stopTimer
              toast.onmouseleave = Swal.resumeTimer
            },

            title: content,
          })
        } else {
        }
      })
      // save map and vector layer references to state
      setMap(map)
      setFeaturesLayer(featuresLayer)
    }
    if (params.id) {
      fetchCoordinates()
    }
     
  }, []) */
  return (
    <>
      <CrudProvider api='system-settings/servers'>
        <FormComponent
          fetch={{
            licenses: 'system-settings/servers/licenses',
            defaultExctractor: 'system-settings/servers/defaultExctractor',
          }}
          redirect='/system-settings/servers'
          text_modificato={intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.EDITED'})}
          text_nuovo={intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.CREATED'})}
        >
          {(formik, data, remoteErrors, isEdit, otherError, item) => (
            <>
              <div className='row mb-6'>
                <div className='col-md-12'>
                  <label htmlFor='serverDescription' className='required fw-bold fs-6'>
                    {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.SERVER_DESCRIPTION'})}
                  </label>

                  <input
                    type='text'
                    className={clsx('form-control', {
                      'is-invalid':
                        (formik.touched.serverDescription && formik.errors.serverDescription) ||
                        remoteErrors.serverDescription !== undefined,
                      'is-valid':
                        formik.touched.serverDescription &&
                        !formik.errors.serverDescription &&
                        remoteErrors.serverDescription === undefined,
                    })}
                    id='serverDescription'
                    name='serverDescription'
                    onChange={formik.handleChange}
                    value={formik.values.serverDescription}
                  />
                  {formik.touched.serverDescription && formik.errors.serverDescription ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {id: formik.errors.serverDescription},
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.SERVERS.SERVER_DESCRIPTION',
                          }),
                        }
                      )}
                    </em>
                  ) : null}
                </div>
              </div>
              <div className='row mb-6'>
                <div className='col-md-5'>
                  <label htmlFor='serverHost' className='required fw-bold fs-6'>
                    {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.SERVER_HOST'})}
                  </label>

                  <input
                    type='text'
                    className={clsx('form-control', {
                      'is-invalid':
                        (formik.touched.serverHost && formik.errors.serverHost) ||
                        remoteErrors.serverHost !== undefined,
                      'is-valid':
                        formik.touched.serverHost &&
                        !formik.errors.serverHost &&
                        remoteErrors.serverHost === undefined,
                    })}
                    id='serverHost'
                    name='serverHost'
                    onChange={formik.handleChange}
                    value={formik.values.serverHost}
                  />

                  {formik.touched.serverHost && formik.errors.serverHost ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {id: formik.errors.serverHost},
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.SERVERS.SERVER_HOST',
                          }),
                        }
                      )}
                    </em>
                  ) : null}
                </div>

                <div className='col-md-2'>
                  <label htmlFor='serverPort' className='required fw-bold fs-6'>
                    {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.SERVER_PORT'})}
                  </label>

                  <input
                    type='text'
                    className={clsx('form-control', {
                      'is-invalid':
                        (formik.touched.serverPort && formik.errors.serverPort) ||
                        remoteErrors.serverPort !== undefined,
                      'is-valid':
                        formik.touched.serverPort &&
                        !formik.errors.serverPort &&
                        remoteErrors.serverPort === undefined,
                    })}
                    id='serverPort'
                    name='serverPort'
                    onChange={formik.handleChange}
                    value={formik.values.serverPort}
                  />

                  {formik.touched.serverPort && formik.errors.serverPort ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {id: formik.errors.serverPort},
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.SERVERS.SERVER_PORT',
                          }),
                        }
                      )}
                    </em>
                  ) : null}
                </div>

                <div className='col-md-5'>
                  <label htmlFor='serverCode' className='required fw-bold fs-6'>
                    {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.SERVER_CODE'})}
                  </label>

                  <input
                    type='text'
                    className={clsx('form-control', {
                      'is-invalid':
                        (formik.touched.serverCode && formik.errors.serverCode) ||
                        remoteErrors.serverCode !== undefined,
                      'is-valid':
                        formik.touched.serverCode &&
                        !formik.errors.serverCode &&
                        remoteErrors.serverCode === undefined,
                    })}
                    id='serverCode'
                    name='serverCode'
                    onChange={formik.handleChange}
                    value={formik.values.serverCode}
                  />

                  {formik.touched.serverCode && formik.errors.serverCode ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {id: formik.errors.serverCode},
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.SERVERS.SERVER_CODE',
                          }),
                        }
                      )}
                    </em>
                  ) : null}
                </div>
              </div>
              <div className='row mb-6'>
                <div className='col-md-4'>
                  <label htmlFor='serverUsername' className='required fw-bold fs-6'>
                    {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.USERNAME'})}
                  </label>

                  <input
                    type='text'
                    className={clsx('form-control', {
                      'is-invalid':
                        (formik.touched.serverUsername && formik.errors.serverUsername) ||
                        remoteErrors.serverUsername !== undefined,
                      'is-valid':
                        formik.touched.serverUsername &&
                        !formik.errors.serverUsername &&
                        remoteErrors.serverUsername === undefined,
                    })}
                    id='serverUsername'
                    name='serverUsername'
                    onChange={formik.handleChange}
                    value={formik.values.serverUsername}
                  />

                  {formik.touched.serverUsername && formik.errors.serverUsername ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {id: formik.errors.serverUsername},
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.SERVERS.USERNAME',
                          }),
                        }
                      )}
                    </em>
                  ) : null}
                </div>

                <div className='col-md-4'>
                  <label
                    htmlFor='serverPassword'
                    className={clsx('fw-bold fs-6', {
                      required: !isEdit,
                    })}
                  >
                    {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.PASSWORD'})}
                  </label>

                  <input
                    type='password'
                    className={clsx('form-control', {
                      'is-invalid':
                        (formik.touched.serverPassword && formik.errors.serverPassword) ||
                        otherError.serverPassword !== undefined,
                      'is-valid':
                        formik.touched.serverPassword &&
                        !formik.errors.serverPassword &&
                        otherError.serverPassword === undefined,
                    })}
                    id='serverPassword'
                    name='serverPassword'
                    onChange={formik.handleChange}
                    value={formik.values.serverPassword}
                  />

                  {otherError.serverPassword ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {
                          id:
                            typeof otherError.serverPassword === 'string'
                              ? otherError.serverPassword
                              : otherError.serverPassword.error,
                        },
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.SERVERS.PASSWORD',
                          }),
                        }
                      )}
                    </em>
                  ) : null}
                  {formik.touched.serverPassword && formik.errors.serverPassword ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {id: formik.errors.serverPassword},
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.SERVERS.PASSWORD',
                          }),
                        }
                      )}
                    </em>
                  ) : null}
                </div>
                <div className='col-md-4'>
                  <label
                    htmlFor='serverConfirmPassword'
                    className={clsx('fw-bold fs-6', {
                      required: !isEdit,
                    })}
                  >
                    {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.CONFIRM_PASSWORD'})}
                  </label>

                  <input
                    type='password'
                    className={clsx('form-control', {
                      'is-invalid':
                        (formik.touched.serverConfirmPassword &&
                          formik.errors.serverConfirmPassword) ||
                        otherError.serverConfirmPassword !== undefined,
                      'is-valid':
                        formik.touched.serverConfirmPassword &&
                        !formik.errors.serverConfirmPassword &&
                        otherError.serverConfirmPassword === undefined,
                    })}
                    id='serverConfirmPassword'
                    name='serverConfirmPassword'
                    onChange={formik.handleChange}
                    value={formik.values.serverConfirmPassword}
                  />

                  {otherError.serverConfirmPassword ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {
                          id:
                            typeof otherError.serverConfirmPassword === 'string'
                              ? otherError.serverConfirmPassword
                              : otherError.serverConfirmPassword.error,
                        },
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.SERVERS.CONFIRM_PASSWORD',
                          }),
                        }
                      )}
                    </em>
                  ) : null}

                  {formik.touched.serverConfirmPassword && formik.errors.serverConfirmPassword ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {id: formik.errors.serverConfirmPassword},
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.SERVERS.CONFIRM_PASSWORD',
                          }),
                        }
                      )}
                    </em>
                  ) : null}
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-md-6'>
                  <label htmlFor='serverPort' className='required fw-bold fs-6'>
                    {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.LATITUDE'})}
                  </label>

                  <input
                    type='number'
                    step='0.000001'
                    className={clsx('form-control', {
                      'is-invalid':
                        (formik.touched.lat && formik.errors.lat) || remoteErrors.lat !== undefined,
                      'is-valid':
                        formik.touched.lat && !formik.errors.lat && remoteErrors.lat === undefined,
                    })}
                    id='lat'
                    name='lat'
                    onChange={formik.handleChange}
                    value={formik.values.lat}
                  />

                  {formik.touched.lat && formik.errors.lat ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {id: formik.errors.lat},
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.SERVERS.LATITUDE',
                          }),
                        }
                      )}
                    </em>
                  ) : null}
                </div>

                <div className='col-md-6'>
                  <label htmlFor='serverPort' className='required fw-bold fs-6'>
                    {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.LONGITUDE'})}
                  </label>

                  <input
                    type='number'
                    step='0.000001'
                    className={clsx('form-control', {
                      'is-invalid':
                        (formik.touched.lat && formik.errors.lng) || remoteErrors.lng !== undefined,
                      'is-valid':
                        formik.touched.lng && !formik.errors.lng && remoteErrors.lng === undefined,
                    })}
                    id='lng'
                    name='lng'
                    onChange={formik.handleChange}
                    value={formik.values.lng}
                  />

                  {formik.touched.lng && formik.errors.lng ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {id: formik.errors.lat},
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.SERVERS.LONGITUDE',
                          }),
                        }
                      )}
                    </em>
                  ) : null}
                </div>
              </div>
              {isEdit && item.oldLicenseToken && (
                <>
                  {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.CURRENT_LICENSE'})}:{' '}
                  <span className='badge badge-primary'>{item.oldLicenseToken}</span>
                </>
              )}

              <div className='row mb-6'>
                <div className='col-md-12'>
                  {isEdit && item.oldLicenseToken && (
                    <label htmlFor='licenseToken' className=' fw-bold fs-6'>
                      {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.NEW_LICENSE'})}
                    </label>
                  )}

                  {(!isEdit || !item.oldLicenseToken) && (
                    <label htmlFor='licenseToken' className=' fw-bold fs-6'>
                      {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.LICENSE'})}
                    </label>
                  )}

                  <select
                    className={clsx('form-control', {
                      'is-invalid':
                        (formik.touched.licenseToken && formik.errors.licenseToken) ||
                        remoteErrors.licenseToken !== undefined,
                      'is-valid':
                        formik.touched.licenseToken &&
                        !formik.errors.licenseToken &&
                        remoteErrors.licenseToken === undefined,
                    })}
                    id='licenseToken'
                    name='licenseToken'
                    onChange={formik.handleChange}
                    value={formik.values.licenseToken}
                  >
                    <option value=''>
                      {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.SELECT_LICENSE'})}
                    </option>
                    {isEdit && item.oldLicenseToken && (
                      <option value='unbind'>
                        {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.REMOVE_LICENSE'})}
                      </option>
                    )}

                    {data &&
                      data.licenses &&
                      data.licenses.map((license: any) => (
                        <option key={license.id} value={license.code}>
                          {license.name} (validity: {license.validity}) - {license.code}
                        </option>
                      ))}
                  </select>
                  {formik.touched.licenseToken && formik.errors.licenseToken ? (
                    <em className='text-danger'>{formik.errors.licenseToken}</em>
                  ) : null}
                </div>
                <div className='col-md-4 mt-5'>
                  {false && (!isEdit || formik.values.autoAddToExctractor != 2) ? (
                    <label
                      className='form-check form-check-inline mt-5'
                      htmlFor='autoAddToExctractor'
                    >
                      <input
                        className='form-check-input'
                        type='checkbox'
                        id='autoAddToExctractor'
                        {...formik.getFieldProps('autoAddToExctractor')}
                        checked={formik.values.autoAddToExctractor ? true : false}
                        onChange={(e) => {
                          formik.setFieldValue(
                            'autoAddToExctractor',
                            e.target.checked ? true : false
                          )
                        }}
                      />

                      {intl.formatMessage(
                        {id: 'SYSTEM_SETTINGS.SERVERS.AUTO_ADD_TO_EXTRACTOR'}
                      )}

                    </label>
                  ) : (
                    <>
                    
                    </>
                  )}
                </div>
              </div>
              {isEdit && item.lat && item.lng && (
                <div
                  ref={mapElement}
                  style={{width: '100%', height: '500px'}}
                  className='map-container'
                ></div>
              )}
            </>
          )}
        </FormComponent>
      </CrudProvider>
    </>
  )
}
